import { useCallback } from 'react'
import { useParams } from 'react-router-dom'

import { routes } from '@/routes/config'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

import { Steps } from '..'

export function useDemandAnalysisRoute() {
  const { companyId, culture, treatment, diagnosisId } = useParams<{
    companyId: string
    culture: Culture
    treatment: Treatment
    diagnosisId: string
  }>()

  const makeUrl = useCallback(
    (step: Steps) => {
      return routes.DemandAnalysis(
        companyId,
        culture,
        treatment,
        diagnosisId,
        step,
      )
    },
    [companyId, culture, treatment, diagnosisId],
  )

  return {
    companyId,
    culture,
    treatment,
    diagnosisId,
    makeUrl,
  }
}
